import React from 'react'
import PropTypes from 'prop-types'
import styles from './SuperscriptSlatePlugin.scss'

const SuperscriptNode = ({ attributes, children }) => (
  <span {...attributes} className={styles.SuperscriptNode}>
    <sup>{children}</sup>
  </span>
)

SuperscriptNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default SuperscriptNode



// WEBPACK FOOTER //
// ./src/components/SuperscriptSlatePlugin/SuperscriptNode.js